<app-header></app-header>

<!-- <app-register></app-register> -->
<!-- <app-payments></app-payments> -->
<router-outlet></router-outlet>
<app-footer></app-footer>
